import * as types from 'types';

export type IRegionConfigWithFilters = types.IRegionConfigWithFilters;

export type IRegionConfig = types.IRegionConfig;

export type IRegionConfigsState = Array<IRegionConfigWithFilters>;

export enum RegionConfigDashboardTypes {
  GET_ALL_REGION_CONFIGS = '@@region-config_dashboard/GET_ALL_REGION_CONFIGS',
  GET_ALL_REGION_CONFIGS_SUCCESS = '@@region-config_dashboard/GET_ALL_REGION_CONFIGS_SUCCESS',
  GET_ALL_REGION_CONFIGS_FAILURE = '@@region-config_dashboard/GET_ALL_REGION_CONFIGS_FAILURE',
  GET_ALL_FILTER_REGION_CONFIGS = '@@region-config_dashboard/GET_ALL_FILTER_REGION_CONFIGS',
  GET_ALL_FILTER_REGION_CONFIGS_SUCCESS = '@@region-config_dashboard/GET_ALL_FILTER_REGION_CONFIGS_SUCCESS',
  GET_ALL_FILTER_REGION_CONFIGS_FAILURE = '@@region-config_dashboard/GET_ALL_FILTER_REGION_CONFIGS_FAILURE',
}
